import { GET_TERMINE_KALENDER_BY_STANDORTID_AND_ZEITRAUM } from '@/domain/termine/hooks/graphql/queries';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  GetTermineKalenderByStandortIdAndZeitraumQuery,
  GetTermineKalenderByStandortIdAndZeitraumQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';

export function useTerminKalenderList(): {
  kalender: TerminKalender[];
  error: Error | null;
} {
  const { currentStandort } = useStandortContext();

  const { data, error } = useSuspenseQuery<
    GetTermineKalenderByStandortIdAndZeitraumQuery,
    GetTermineKalenderByStandortIdAndZeitraumQueryVariables
  >(GET_TERMINE_KALENDER_BY_STANDORTID_AND_ZEITRAUM, {
    variables: {
      standortIds: [currentStandort.id],
    },
    fetchPolicy: 'cache-and-network',
  });

  if (error || !data) {
    return { kalender: [], error: error ?? new Error('No data') };
  }

  const kalenderResult = data?.termine_termineKalenderByStandortIdAndZeitraum;
  if (!kalenderResult || kalenderResult.length === 0) {
    return { kalender: [], error: null };
  }

  return { kalender: kalenderResult, error: null };
}
